import { createContext, useCallback, useContext, useState } from "react";
import SignupDialog from "@/components/SignupDialog";

const SignupCtx = createContext({ open: false, openSignup: () => {}, closeSignup: () => {} });

export function SignupProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openSignup = useCallback(() => setOpen(true), []);
  const closeSignup = useCallback(() => setOpen(false), []);
  return (
    <SignupCtx.Provider value={{ open, openSignup, closeSignup }}>
      {children}
      <SignupDialog open={open} onOpenChange={setOpen} />
    </SignupCtx.Provider>
  );
}

export function useSignup() {
  return useContext(SignupCtx);
}
